import React from 'react';
import styled from 'styled-components';
import Nav from './Nav';
import Logo from '../../../assets/images/logo-black';

const StyledWrapper = styled.div`
  && .container {
    max-width: none;
    padding: 0 24px;
  }

  .navbar__text + button {
    visibility: ${({ hideCloseIcon }) => (hideCloseIcon ? 'hidden' : 'visible')};

    @media screen and (min-width: 768px) {
      min-width: 105px;
    }

    @media screen and (max-width: 767px) {
      padding-right: 0;
    }
  }

  .navbar__icon-button:first-child {
    visibility: ${({ showBackButton }) => (showBackButton ? 'visible' : 'hidden')};
    background-color: transparent !important;
    @media screen and (min-width: 768px) {
      min-width: 105px;
    }

    @media screen and (max-width: 767px) {
      padding-left: 0;
    }
  }

  @media screen and (min-width: 768px) {
    .navbar__icon-button:first-child::after {
      content: 'Voltar';
      position: relative;
      color: #9000ff;
      font-size: 10px;
      text-transform: uppercase;
      margin-left: 12px;
      font-weight: 500;
      top: -4px;
    }
  }
`;

const Navbar = props => {
  const { hideCloseIcon, showBackButton, ...other } = props;
  return (
    <StyledWrapper hideCloseIcon={hideCloseIcon} showBackButton={showBackButton}>
      <Nav navText={<Logo width={80} responsiveWidth={64} />} {...other} showBackButton />
    </StyledWrapper>
  );
};

export default Navbar;
